const textDefaults = {
	'EN': {
		'welcomeTitle': 'ID Card Identification',
		'welcomeReason': 'We need to verify your identity. Please upload one of the accepted documents and provide your personal information.',
		'documentUploadTitle': 'Upload your ID document',
		'documentUploadText': 'Capture or select an image of your document where the edges are visible and all text is clearly readable.',
		'personalInfoTitle': 'Personal Information',
		'personalInfoDescription': 'Please provide your personal information. Fields marked with * are required.',
		'firstNameLabel': 'First Name',
		'lastNameLabel': 'Last Name',
		'phoneLabel': 'Phone',
		'dateOfBirthLabel': 'Date of Birth',
		'idCardNumberLabel': 'ID Card Number',
		'companyLabel': 'Company',
		'licensePlateLabel': 'License Plate',
		'fixedPhoneLineLabel': 'Fixed Phone Line',
		'selfieTitle': 'Take a Selfie',
		'selfieDescription': 'Please take a selfie to complete your identification.',
		'nationalIdLabel': 'National ID',
		'passportLabel': 'Passport',
		'driversLicenseLabel': 'Driver\'s License',
		'residencePermitLabel': 'Residence Permit',
		'orLabel': 'or',
		'errorNotRecognised': 'Document not recognized',
		'errorWrongType': 'Please upload the correct document or a clear image of the document.',
		'errorUnsupportedClass': 'We couldn\'t verify this image. Please upload the front side of the requested document.',
		'errorNameNotFound': 'Name is not found on document',
		'errorNameMismatch': 'Name of the user performing the task does not match the name on the document',
		'feedbackReview': 'Provisionally accepted, pending review',
		'lblCountry': 'Country',
		'lblExpires': 'Expires',
		'lblUploadOrCapture': 'Upload or take a picture',
		'expiredError': 'Document expired or will expire too soon',
		'confirm': 'Confirm',
		'retry': 'Retry',
		'error': 'Something went wrong, please try again',
		'errorDropdownTitle': 'I got an error, what does this mean?',
		'continueWithErrorExplainer': 'We were not able to process your file. In case you think you uploaded the right file, you can click the continue button, but this will put your user in review and will not give you access without being reviewed first.',
		'cancelErrorButton': 'Cancel',
		'acceptErrorButton': 'Continue Anyway',
		'typePickerTitle': 'Which document do you have?',
		'typePickerSubtitle': 'Choose the official document you\'d like to use.',
		'sidesOne': '1 side',
		'sidesTwo': '2 sides',
		'sidesOneCaption': 'Single page',
		'sidesTwoCaption': 'Front & back',
		'slotFront': 'Front',
		'slotBack': 'Back',
		'slotPhotoPage': 'Photo page',
		'slotTapToCapture': 'Tap to capture',
		'slotCaptured': 'Captured · tap to retake',
		'slotFlaggedBlur': 'Looks blurry, tap to retake',
		'verifyDocument': 'Verify document',
		'documentVerified': 'Document verified',
		'verifyHint': 'Make sure your photos are sharp and the text is readable.',
		'verifyingTitle': 'Checking your document…',
		'verifyingBody': 'Matching the details on your document, this takes a few seconds.',
		'changeDocument': 'Change',
		'camHeaderFront': 'Position the front of your document in the frame',
		'camHeaderBack': 'Position the back of your document in the frame',
		'camHeaderPhotoPage': 'Position the photo page in the frame',
		'camCapture': 'Capture',
		'camCancel': 'Cancel',
		'cameraDenied': 'Can\'t access your camera',
		'cameraDeniedHint': 'Please make sure camera access is turned on, then try again. You can also upload a file instead.',
		'cameraDeniedAction': 'Upload a file instead',
		'useCameraAction': 'Use camera',
		'slotCamera': 'Camera',
		'slotUpload': 'Upload',
		'slotCameraMain': 'Take a photo',
		'slotUploadMain': 'Upload a file',
		'slotCameraOpen': 'Open the camera',
		'chooseTypeCrumb': 'Choose type',
		'bothSidesButton': 'Upload one file with both sides',
		'bothSidesCaption': 'Both sides · one file',
		'bothSidesReplace': 'tap to replace',
		'captureEachSide': 'Capture each side instead',
	},
	'FR': {
		'welcomeTitle': 'Identification par carte d\'identité',
		'welcomeReason': 'Nous devons vérifier votre identité. Veuillez télécharger l\'un des documents acceptés et fournir vos informations personnelles.',
		'documentUploadTitle': 'Téléchargez votre document d\'identité',
		'documentUploadText': 'Prenez ou sélectionnez une image de votre document où les bords sont visibles et tout le texte est clairement lisible.',
		'personalInfoTitle': 'Informations personnelles',
		'personalInfoDescription': 'Veuillez fournir vos informations personnelles. Les champs marqués d\'un * sont obligatoires.',
		'firstNameLabel': 'Prénom',
		'lastNameLabel': 'Nom',
		'phoneLabel': 'Téléphone',
		'dateOfBirthLabel': 'Date de naissance',
		'idCardNumberLabel': 'Numéro de carte d\'identité',
		'companyLabel': 'Entreprise',
		'licensePlateLabel': 'Plaque d\'immatriculation',
		'fixedPhoneLineLabel': 'Ligne téléphonique fixe',
		'selfieTitle': 'Prenez un selfie',
		'selfieDescription': 'Veuillez prendre un selfie pour compléter votre identification.',
		'nationalIdLabel': 'Carte d\'identité nationale',
		'passportLabel': 'Passeport',
		'driversLicenseLabel': 'Permis de conduire',
		'residencePermitLabel': 'Permis de séjour',
		'orLabel': 'ou',
		'errorNotRecognised': 'Document non reconnu',
		'errorWrongType': 'Veuillez télécharger le document correct ou une image claire du document.',
		'errorUnsupportedClass': 'Nous n\'avons pas pu vérifier cette image. Veuillez télécharger le recto du document demandé.',
		'errorNameNotFound': 'Le nom n\'est pas trouvé sur le document',
		'errorNameMismatch': 'Le nom de l\'utilisateur effectuant la tâche ne correspond pas au nom sur le document',
		'feedbackReview': 'Accepté provisoirement, en attente de révision',
		'documentVerified': 'Document vérifié',
		'lblCountry': 'Pays',
		'lblExpires': 'Expire',
		'lblUploadOrCapture': 'Téléchargez ou prenez une photo',
		'expiredError': 'Document expiré ou expirera trop rapidement',
		'confirm': 'Confirmer',
		'retry': 'Réessayer',
		'error': 'Quelque chose s\'est mal passé, veuillez réessayer',
		'errorDropdownTitle': 'J\'ai une erreur, qu\'est-ce que cela signifie?',
		'continueWithErrorExplainer': 'Nous n\'avons pas pu traiter votre fichier. Si vous pensez avoir téléchargé le bon fichier, vous pouvez cliquer sur le bouton continuer, mais cela mettra votre utilisateur en révision et ne vous donnera pas accès sans être révisé en premier.',
		'cancelErrorButton': 'Annuler',
		'acceptErrorButton': 'Continuer quand même',
	},
	'DE': {
		'welcomeTitle': 'Identifikation per Personalausweis',
		'welcomeReason': 'Wir müssen Ihre Identität überprüfen. Bitte laden Sie eines der akzeptierten Dokumente hoch und geben Sie Ihre persönlichen Informationen an.',
		'documentUploadTitle': 'Laden Sie Ihr Ausweisdokument hoch',
		'documentUploadText': 'Erfassen oder wählen Sie ein Bild Ihres Dokuments, bei dem die Ränder sichtbar sind und der gesamte Text gut lesbar ist.',
		'personalInfoTitle': 'Persönliche Informationen',
		'personalInfoDescription': 'Bitte geben Sie Ihre persönlichen Informationen an. Mit * markierte Felder sind erforderlich.',
		'firstNameLabel': 'Vorname',
		'lastNameLabel': 'Nachname',
		'phoneLabel': 'Telefon',
		'dateOfBirthLabel': 'Geburtsdatum',
		'idCardNumberLabel': 'Personalausweisnummer',
		'companyLabel': 'Unternehmen',
		'licensePlateLabel': 'Kennzeichen',
		'fixedPhoneLineLabel': 'Festnetz',
		'selfieTitle': 'Machen Sie ein Selfie',
		'selfieDescription': 'Bitte machen Sie ein Selfie, um Ihre Identifikation abzuschließen.',
		'nationalIdLabel': 'Personalausweis',
		'passportLabel': 'Reisepass',
		'driversLicenseLabel': 'Führerschein',
		'residencePermitLabel': 'Aufenthaltserlaubnis',
		'orLabel': 'oder',
		'errorNotRecognised': 'Dokument nicht erkannt',
		'errorWrongType': 'Bitte laden Sie das korrekte Dokument oder ein klares Bild des Dokuments hoch.',
		'errorUnsupportedClass': 'Wir konnten dieses Bild nicht verifizieren. Bitte laden Sie die Vorderseite des angeforderten Dokuments hoch.',
		'errorNameNotFound': 'Name wurde auf dem Dokument nicht gefunden',
		'errorNameMismatch': 'Der Name des Benutzers, der die Aufgabe ausführt, stimmt nicht mit dem Namen auf dem Dokument überein',
		'feedbackReview': 'Vorläufig akzeptiert, ausstehende Überprüfung',
		'documentVerified': 'Dokument verifiziert',
		'lblCountry': 'Land',
		'lblExpires': 'Läuft ab',
		'lblUploadOrCapture': 'Hochladen oder ein Bild aufnehmen',
		'expiredError': 'Dokument verloren oder wird zu bald ablaufen',
		'confirm': 'Bestätigen',
		'retry': 'Wiederholen',
		'error': 'Etwas ist schiefgegangen, bitte versuchen Sie es erneut',
		'errorDropdownTitle': 'Ich habe einen Fehler erhalten, was bedeutet das?',
		'continueWithErrorExplainer': 'Wir konnten Ihre Datei nicht verarbeiten. Falls Sie denken, dass Sie die richtige Datei hochgeladen haben, können Sie auf die Schaltfläche „Fortfahren" klicken, aber dies wird Ihren Benutzer zur Überprüfung stellen und Ihnen keinen Zugriff gewähren, ohne zuerst überprüft zu werden.',
		'cancelErrorButton': 'Abbrechen',
		'acceptErrorButton': 'Trotzdem fortfahren',
	},
	'NL': {
		'welcomeTitle': 'Identificatie met ID-kaart',
		'welcomeReason': 'We moeten uw identiteit verifiëren. Upload een van de geaccepteerde documenten en verstrek uw persoonlijke informatie.',
		'documentUploadTitle': 'Upload uw identiteitsbewijs',
		'documentUploadText': 'Maak of selecteer een afbeelding van uw document waarbij de randen zichtbaar zijn en alle tekst goed leesbaar is.',
		'personalInfoTitle': 'Persoonlijke informatie',
		'personalInfoDescription': 'Verstrek uw persoonlijke informatie. Velden gemarkeerd met * zijn verplicht.',
		'firstNameLabel': 'Voornaam',
		'lastNameLabel': 'Achternaam',
		'phoneLabel': 'Telefoon',
		'dateOfBirthLabel': 'Geboortedatum',
		'idCardNumberLabel': 'ID-kaartnummer',
		'companyLabel': 'Bedrijf',
		'licensePlateLabel': 'Kenteken',
		'fixedPhoneLineLabel': 'Vaste telefonielijn',
		'selfieTitle': 'Maak een selfie',
		'selfieDescription': 'Maak een selfie om uw identificatie te voltooien.',
		'nationalIdLabel': 'Nationale ID-kaart',
		'passportLabel': 'Paspoort',
		'driversLicenseLabel': 'Rijbewijs',
		'residencePermitLabel': 'Verblijfsvergunning',
		'orLabel': 'of',
		'errorNotRecognised': 'Document niet herkend',
		'errorWrongType': 'Upload het juiste document of een duidelijke afbeelding van het document.',
		'errorUnsupportedClass': 'We konden deze afbeelding niet verifiëren. Upload de voorkant van het gevraagde document.',
		'errorNameNotFound': 'Naam niet gevonden op document',
		'errorNameMismatch': 'Naam van de gebruiker die de taak uitvoert komt niet overeen met de naam op het document',
		'feedbackReview': 'Voorlopig geaccepteerd, in afwachting van beoordeling',
		'documentVerified': 'Document geverifieerd',
		'lblCountry': 'Land',
		'lblExpires': 'Verloopt',
		'lblUploadOrCapture': 'Upload of maak een foto',
		'expiredError': 'Document verlopen of zal te snel verlopen',
		'confirm': 'Bevestigen',
		'retry': 'Opnieuw proberen',
		'error': 'Er is iets misgegaan, probeer het opnieuw',
		'errorDropdownTitle': 'Ik heb een foutmelding gekregen, wat betekent dit?',
		'continueWithErrorExplainer': 'We konden uw bestand niet verwerken. Als u denkt dat u het juiste bestand heeft geüpload, kunt u op de knop doorgaan klikken, maar dit zal uw gebruiker in beoordeling plaatsen en u geen toegang geven zonder eerst te worden beoordeeld.',
		'cancelErrorButton': 'Annuleren',
		'acceptErrorButton': 'Toch doorgaan',
	},
	'PL': {
		'welcomeTitle': 'Identyfikacja za pomocą dowodu osobistego',
		'welcomeReason': 'Musimy zweryfikować Twoją tożsamość. Prześlij jeden z akceptowanych dokumentów i podaj swoje dane osobowe.',
		'documentUploadTitle': 'Prześlij swój dokument tożsamości',
		'documentUploadText': 'Zrób lub wybierz zdjęcie dokumentu, na którym krawędzie są widoczne, a cały tekst jest czytelny.',
		'personalInfoTitle': 'Dane osobowe',
		'personalInfoDescription': 'Proszę podać swoje dane osobowe. Pola oznaczone * są wymagane.',
		'firstNameLabel': 'Imię',
		'lastNameLabel': 'Nazwisko',
		'phoneLabel': 'Telefon',
		'dateOfBirthLabel': 'Data urodzenia',
		'idCardNumberLabel': 'Numer dowodu osobistego',
		'companyLabel': 'Firma',
		'licensePlateLabel': 'Numer rejestracyjny',
		'fixedPhoneLineLabel': 'Telefon stacjonarny',
		'selfieTitle': 'Zrób selfie',
		'selfieDescription': 'Proszę zrobić selfie, aby zakończyć identyfikację.',
		'nationalIdLabel': 'Dowód osobisty',
		'passportLabel': 'Paszport',
		'driversLicenseLabel': 'Prawo jazdy',
		'residencePermitLabel': 'Karta pobytu',
		'orLabel': 'lub',
		'errorNotRecognised': 'Dokument nierozpoznany',
		'errorWrongType': 'Proszę przesłać właściwy dokument lub wyraźne zdjęcie dokumentu.',
		'errorUnsupportedClass': 'Nie mogliśmy zweryfikować tego obrazu. Proszę przesłać przód żądanego dokumentu.',
		'errorNameNotFound': 'Nie znaleziono imienia i nazwiska na dokumencie',
		'errorNameMismatch': 'Imię i nazwisko użytkownika wykonującego zadanie nie pasuje do imienia i nazwiska na dokumencie',
		'feedbackReview': 'Tymczasowo zaakceptowano, w oczekiwaniu na weryfikację',
		'lblCountry': 'Kraj',
		'lblExpires': 'Wygasa',
		'lblUploadOrCapture': 'Prześlij lub zrób zdjęcie',
		'expiredError': 'Dokument wygasł lub wygaśnie za krótko',
		'confirm': 'Potwierdź',
		'retry': 'Ponów',
		'error': 'Coś poszło nie tak, spróbuj ponownie',
		'errorDropdownTitle': 'Otrzymałem błąd, co to znaczy?',
		'continueWithErrorExplainer': 'Nie mogliśmy przetworzyć Twojego pliku. Jeśli uważasz, że przesłałeś właściwy plik, możesz kliknąć przycisk kontynuuj, ale spowoduje to umieszczenie użytkownika w przeglądzie i nie da Ci dostępu bez wcześniejszego przeglądu.',
		'cancelErrorButton': 'Anuluj',
		'acceptErrorButton': 'Kontynuuj mimo to',
	},
	'BG': {
		'welcomeTitle': 'Идентификация с карта за самоличност',
		'welcomeReason': 'Трябва да проверим самоличността ви. Моля, качете един от приетите документи и предоставете личната си информация.',
		'documentUploadTitle': 'Качете вашия документ за самоличност',
		'documentUploadText': 'Направете или изберете снимка на документа, където краищата са видими и целият текст е ясно четим.',
		'personalInfoTitle': 'Лична информация',
		'personalInfoDescription': 'Моля, предоставете личната си информация. Полетата, маркирани с *, са задължителни.',
		'firstNameLabel': 'Първо име',
		'lastNameLabel': 'Фамилия',
		'phoneLabel': 'Телефон',
		'dateOfBirthLabel': 'Дата на раждане',
		'idCardNumberLabel': 'Номер на карта за самоличност',
		'companyLabel': 'Компания',
		'licensePlateLabel': 'Регистрационен номер',
		'fixedPhoneLineLabel': 'Стационарен телефон',
		'selfieTitle': 'Направете селфи',
		'selfieDescription': 'Моля, направете селфи, за да завършите идентификацията си.',
		'nationalIdLabel': 'Национална карта за самоличност',
		'passportLabel': 'Пасорт',
		'driversLicenseLabel': 'Шофьорска книжка',
		'residencePermitLabel': 'Разрешение за пребиваване',
		'orLabel': 'или',
		'errorNotRecognised': 'Документът не е разпознат',
		'errorWrongType': 'Моля, качете правилния документ или ясна снимка на документа.',
		'errorUnsupportedClass': 'Не можахме да проверим това изображение. Моля, качете лицевата страна на искания документ.',
		'errorNameNotFound': 'Името не е намерено на документа',
		'errorNameMismatch': 'Името на потребителя, изпълняващ задачата, не съвпада с името на документа',
		'feedbackReview': 'Временно приет, изчаква проверка',
		'lblCountry': 'Държава',
		'lblExpires': 'Изтича',
		'lblUploadOrCapture': 'Качете или направете снимка',
		'expiredError': 'Документът е изтекъл или ще изтече твърде скоро',
		'confirm': 'Потвърди',
		'retry': 'Нов опит',
		'error': 'Нещо се обърка, моля опитайте отново',
	},
	'CS': {
		'welcomeTitle': 'Identifikace pomocí občanského průkazu',
		'welcomeReason': 'Musíme ověřit vaši identitu. Nahrajte prosím jeden z přijatých dokumentů a uveďte své osobní údaje.',
		'documentUploadTitle': 'Nahrajte svůj identifikační dokument',
		'documentUploadText': 'Pořiďte nebo vyberte obrázek dokumentu, kde jsou okraje viditelné a veškerý text je jasně čitelný.',
		'personalInfoTitle': 'Osobní informace',
		'personalInfoDescription': 'Uveďte prosím své osobní údaje. Pole označená * jsou povinná.',
		'firstNameLabel': 'Jméno',
		'lastNameLabel': 'Příjmení',
		'phoneLabel': 'Telefon',
		'dateOfBirthLabel': 'Datum narození',
		'idCardNumberLabel': 'Číslo občanského průkazu',
		'companyLabel': 'Společnost',
		'licensePlateLabel': 'SPZ',
		'fixedPhoneLineLabel': 'Pevná linka',
		'selfieTitle': 'Pořiďte selfie',
		'selfieDescription': 'Pořiďte prosím selfie pro dokončení identifikace.',
		'nationalIdLabel': 'Občanský průkaz',
		'passportLabel': 'Cestovní pas',
		'driversLicenseLabel': 'Řidičský průkaz',
		'residencePermitLabel': 'Povolení k pobytu',
		'orLabel': 'nebo',
		'errorNotRecognised': 'Dokument nerozpoznán',
		'errorWrongType': 'Nahrajte prosím správný dokument nebo jasný obrázek dokumentu.',
		'errorUnsupportedClass': 'Nemohli jsme ověřit tento obrázek. Nahrajte prosím přední stranu požadovaného dokumentu.',
		'errorNameNotFound': 'Jméno nebylo nalezeno na dokumentu',
		'errorNameMismatch': 'Jméno uživatele provádějícího úlohu neodpovídá jménu na dokumentu',
		'feedbackReview': 'Předběžně přijato, čeká na kontrolu',
		'lblCountry': 'Země',
		'lblExpires': 'Vyprší',
		'lblUploadOrCapture': 'Nahrát nebo pořídit obrázek',
		'expiredError': 'Dokument vypršel nebo brzy vyprší',
		'confirm': 'Potvrdit',
		'retry': 'Zkusit znovu',
		'error': 'Něco se pokazilo, zkuste to prosím znovu',
	},
	'DA': {
		'welcomeTitle': 'ID-kort identifikation',
		'welcomeReason': 'Vi skal verificere din identitet. Upload venligst et af de accepterede dokumenter og angiv dine personlige oplysninger.',
		'documentUploadTitle': 'Upload dit ID-dokument',
		'documentUploadText': 'Tag eller vælg et billede af dit dokument hvor kanterne er synlige og al tekst er tydeligt læsbar.',
		'personalInfoTitle': 'Personlige oplysninger',
		'personalInfoDescription': 'Angiv venligst dine personlige oplysninger. Felter markeret med * er påkrævet.',
		'firstNameLabel': 'Fornavn',
		'lastNameLabel': 'Efternavn',
		'phoneLabel': 'Telefon',
		'dateOfBirthLabel': 'Fødselsdato',
		'idCardNumberLabel': 'ID-kortnummer',
		'companyLabel': 'Virksomhed',
		'licensePlateLabel': 'Nummerplade',
		'fixedPhoneLineLabel': 'Fastnet',
		'selfieTitle': 'Tag et selfie',
		'selfieDescription': 'Tag venligst et selfie for at fuldføre din identifikation.',
		'nationalIdLabel': 'Nationalt ID',
		'passportLabel': 'Pas',
		'driversLicenseLabel': 'Kørekort',
		'residencePermitLabel': 'Opholdstilladelse',
		'orLabel': 'eller',
		'errorNotRecognised': 'Dokument ikke genkendt',
		'errorWrongType': 'Upload venligst det korrekte dokument eller et klart billede af dokumentet.',
		'errorUnsupportedClass': 'Vi kunne ikke verificere dette billede. Upload venligst forsiden af det anmodede dokument.',
		'errorNameNotFound': 'Navn ikke fundet på dokumentet',
		'errorNameMismatch': 'Navnet på brugeren, der udfører opgaven, matcher ikke navnet på dokumentet',
		'feedbackReview': 'Foreløbigt accepteret, afventer gennemgang',
		'lblCountry': 'Land',
		'lblExpires': 'Udløber',
		'lblUploadOrCapture': 'Upload eller tag et billede',
		'expiredError': 'Dokument udløbet eller vil udløbe for snart',
		'confirm': 'Bekræft',
		'retry': 'Prøv igen',
		'error': 'Noget gik galt, prøv venligst igen',
	},
	'ES': {
		'welcomeTitle': 'Identificación con tarjeta de identidad',
		'welcomeReason': 'Necesitamos verificar su identidad. Por favor suba uno de los documentos aceptados y proporcione su información personal.',
		'documentUploadTitle': 'Suba su documento de identidad',
		'documentUploadText': 'Captura o selecciona una imagen de tu documento donde los bordes sean visibles y todo el texto esté claramente legible.',
		'personalInfoTitle': 'Información personal',
		'personalInfoDescription': 'Por favor proporcione su información personal. Los campos marcados con * son obligatorios.',
		'firstNameLabel': 'Nombre',
		'lastNameLabel': 'Apellido',
		'phoneLabel': 'Teléfono',
		'dateOfBirthLabel': 'Fecha de nacimiento',
		'idCardNumberLabel': 'Número de tarjeta de identidad',
		'companyLabel': 'Empresa',
		'licensePlateLabel': 'Matrícula',
		'fixedPhoneLineLabel': 'Línea telefónica fija',
		'selfieTitle': 'Tome un selfie',
		'selfieDescription': 'Por favor tome un selfie para completar su identificación.',
		'nationalIdLabel': 'DNI',
		'passportLabel': 'Pasaporte',
		'driversLicenseLabel': 'Licencia de conducir',
		'residencePermitLabel': 'Permiso de residencia',
		'orLabel': 'o',
		'errorNotRecognised': 'Documento no reconocido',
		'errorWrongType': 'Por favor suba el documento correcto o una imagen clara del documento.',
		'errorUnsupportedClass': 'No pudimos verificar esta imagen. Por favor suba el lado frontal del documento solicitado.',
		'errorNameNotFound': 'El nombre no se encontró en el documento',
		'errorNameMismatch': 'El nombre del usuario que realiza la tarea no coincide con el nombre en el documento',
		'feedbackReview': 'Aceptado provisionalmente, pendiente de revisión',
		'documentVerified': 'Documento verificado',
		'lblCountry': 'País',
		'lblExpires': 'Vence',
		'lblUploadOrCapture': 'Sube o toma una foto',
		'expiredError': 'Documento vencido o vencerá demasiado pronto',
		'confirm': 'Confirmar',
		'retry': 'Reintentar',
		'error': 'Algo salió mal, por favor intente de nuevo',
	},
	'FI': {
		'welcomeTitle': 'Henkilötodistuksen tunnistus',
		'welcomeReason': 'Meidän on vahvistettava henkilöllisyytesi. Lataa yksi hyväksytyistä asiakirjoista ja anna henkilötietosi.',
		'documentUploadTitle': 'Lataa henkilöllisyystodistuksesi',
		'documentUploadText': 'Ota tai valitse kuva asiakirjastasi, jossa reunat ovat näkyvissä ja kaikki teksti on selkeästi luettavissa.',
		'personalInfoTitle': 'Henkilötiedot',
		'personalInfoDescription': 'Anna henkilötietosi. Tähdellä merkityt kentät ovat pakollisia.',
		'firstNameLabel': 'Etunimi',
		'lastNameLabel': 'Sukunimi',
		'phoneLabel': 'Puhelin',
		'dateOfBirthLabel': 'Syntymäaika',
		'idCardNumberLabel': 'Henkilökortin numero',
		'companyLabel': 'Yritys',
		'licensePlateLabel': 'Rekisterinumero',
		'fixedPhoneLineLabel': 'Kiinteä puhelinlinja',
		'selfieTitle': 'Ota selfie',
		'selfieDescription': 'Ota selfie tunnistautumisesi viimeistelemiseksi.',
		'nationalIdLabel': 'Kansallinen henkilötodistus',
		'passportLabel': 'Passi',
		'driversLicenseLabel': 'Ajokortti',
		'residencePermitLabel': 'Oleskelulupa',
		'orLabel': 'tai',
		'errorNotRecognised': 'Asiakirjaa ei tunnistettu',
		'errorWrongType': 'Lataa oikea asiakirja tai selkeä kuva asiakirjasta.',
		'errorUnsupportedClass': 'Emme voineet vahvistaa tätä kuvaa. Lataa pyydetyn asiakirjan etupuoli.',
		'errorNameNotFound': 'Nimeä ei löytynyt asiakirjasta',
		'errorNameMismatch': 'Tehtävää suorittavan käyttäjän nimi ei vastaa asiakirjan nimeä',
		'feedbackReview': 'Ehdollisesti hyväksytty, odottaa tarkistusta',
		'lblCountry': 'Maa',
		'lblExpires': 'Vanhenee',
		'lblUploadOrCapture': 'Lataa tai ota kuva',
		'expiredError': 'Asiakirja vanhentunut tai vanhenee liian pian',
		'confirm': 'Vahvista',
		'retry': 'Yritä uudelleen',
		'error': 'Jotain meni pieleen, yritä uudelleen',
	},
	'HR': {
		'welcomeTitle': 'Identifikacija s osobnom iskaznicom',
		'welcomeReason': 'Moramo potvrditi vaš identitet. Molimo učitajte jedan od prihvaćenih dokumenata i navedite svoje osobne podatke.',
		'documentUploadTitle': 'Učitajte svoj identifikacijski dokument',
		'documentUploadText': 'Snimite ili odaberite sliku vašeg dokumenta gdje su rubovi vidljivi i sav tekst je jasno čitljiv.',
		'personalInfoTitle': 'Osobne informacije',
		'personalInfoDescription': 'Molimo navedite svoje osobne podatke. Polja označena s * su obavezna.',
		'firstNameLabel': 'Ime',
		'lastNameLabel': 'Prezime',
		'phoneLabel': 'Telefon',
		'dateOfBirthLabel': 'Datum rođenja',
		'idCardNumberLabel': 'Broj osobne iskaznice',
		'companyLabel': 'Tvrtka',
		'licensePlateLabel': 'Registarska oznaka',
		'fixedPhoneLineLabel': 'Fiksna telefonska linija',
		'selfieTitle': 'Napravite selfie',
		'selfieDescription': 'Molimo napravite selfie za dovršetak identifikacije.',
		'nationalIdLabel': 'Osobna iskaznica',
		'passportLabel': 'Putovnica',
		'driversLicenseLabel': 'Vozačka dozvola',
		'residencePermitLabel': 'Dozvola boravka',
		'orLabel': 'ili',
		'errorNotRecognised': 'Dokument nije prepoznat',
		'errorWrongType': 'Molimo učitajte ispravan dokument ili jasnu sliku dokumenta.',
		'errorUnsupportedClass': 'Nismo mogli potvrditi ovu sliku. Molimo učitajte prednju stranu traženog dokumenta.',
		'errorNameNotFound': 'Ime nije pronađeno na dokumentu',
		'errorNameMismatch': 'Ime korisnika koji izvršava zadatak ne odgovara imenu na dokumentu',
		'feedbackReview': 'Uvjetno prihvaćeno, čeka pregled',
		'lblCountry': 'Zemlja',
		'lblExpires': 'Istječe',
		'lblUploadOrCapture': 'Učitaj ili snimi sliku',
		'expiredError': 'Dokument je istekao ili će uskoro isteći',
		'confirm': 'Potvrdi',
		'retry': 'Pokušaj ponovno',
		'error': 'Nešto je pošlo po zlu, molimo pokušajte ponovno',
	},
	'HU': {
		'welcomeTitle': 'Személyigazolvány azonosítás',
		'welcomeReason': 'Ellenőriznünk kell az Ön személyazonosságát. Kérjük, töltse fel az egyik elfogadott dokumentumot és adja meg személyes adatait.',
		'documentUploadTitle': 'Töltse fel az igazolványát',
		'documentUploadText': 'Készítsen vagy válasszon egy képet a dokumentumáról, ahol a szélek láthatók és az összes szöveg jól olvasható.',
		'personalInfoTitle': 'Személyes információk',
		'personalInfoDescription': 'Kérjük, adja meg személyes adatait. A * jellel jelölt mezők kötelezőek.',
		'firstNameLabel': 'Keresztnév',
		'lastNameLabel': 'Vezetéknév',
		'phoneLabel': 'Telefon',
		'dateOfBirthLabel': 'Születési dátum',
		'idCardNumberLabel': 'Személyigazolvány száma',
		'companyLabel': 'Vállalat',
		'licensePlateLabel': 'Rendszám',
		'fixedPhoneLineLabel': 'Rögzített telefonvonal',
		'selfieTitle': 'Készítsen selfie-t',
		'selfieDescription': 'Kérjük, készítsen selfie-t az azonosítás befejezéséhez.',
		'nationalIdLabel': 'Személyigazolvány',
		'passportLabel': 'Útlevél',
		'driversLicenseLabel': 'Vezetői engedély',
		'residencePermitLabel': 'Tartózkodási engedély',
		'orLabel': 'vagy',
		'errorNotRecognised': 'Dokumentum nem felismerhető',
		'errorWrongType': 'Kérjük, töltse fel a megfelelő dokumentumot vagy a dokumentum tiszta képét.',
		'errorUnsupportedClass': 'Nem tudtuk ellenőrizni ezt a képet. Kérjük, töltse fel a kért dokumentum elülső oldalát.',
		'errorNameNotFound': 'A név nem található a dokumentumon',
		'errorNameMismatch': 'A feladatot végrehajtó felhasználó neve nem egyezik a dokumentumon szereplő névvel',
		'feedbackReview': 'Ideiglenesen elfogadva, felülvizsgálatra vár',
		'lblCountry': 'Ország',
		'lblExpires': 'Lejár',
		'lblUploadOrCapture': 'Feltöltés vagy fénykép készítése',
		'expiredError': 'Dokumentum lejárt vagy túl hamar le fog járni',
		'confirm': 'Megerősít',
		'retry': 'Újra',
		'error': 'Valami elromlott, kérjük próbálja újra',
	},
	'IT': {
		'welcomeTitle': 'Identificazione con carta d\'identità',
		'welcomeReason': 'Dobbiamo verificare la tua identità. Carica uno dei documenti accettati e fornisci le tue informazioni personali.',
		'documentUploadTitle': 'Carica il tuo documento d\'identità',
		'documentUploadText': 'Cattura o seleziona un\'immagine del tuo documento dove i bordi sono visibili e tutto il testo è chiaramente leggibile.',
		'personalInfoTitle': 'Informazioni personali',
		'personalInfoDescription': 'Si prega di fornire le informazioni personali. I campi contrassegnati con * sono obbligatori.',
		'firstNameLabel': 'Nome',
		'lastNameLabel': 'Cognome',
		'phoneLabel': 'Telefono',
		'dateOfBirthLabel': 'Data di nascita',
		'idCardNumberLabel': 'Numero carta d\'identità',
		'companyLabel': 'Azienda',
		'licensePlateLabel': 'Targa',
		'fixedPhoneLineLabel': 'Linea telefonica fissa',
		'selfieTitle': 'Scatta un selfie',
		'selfieDescription': 'Si prega di scattare un selfie per completare la tua identificazione.',
		'nationalIdLabel': 'Carta d\'identità nazionale',
		'passportLabel': 'Passaporto',
		'driversLicenseLabel': 'Patente di guida',
		'residencePermitLabel': 'Permesso di soggiorno',
		'orLabel': 'o',
		'errorNotRecognised': 'Documento non riconosciuto',
		'errorWrongType': 'Carica il documento corretto o un\'immagine chiara del documento.',
		'errorUnsupportedClass': 'Non siamo riusciti a verificare questa immagine. Carica il lato anteriore del documento richiesto.',
		'errorNameNotFound': 'Il nome non è stato trovato sul documento',
		'errorNameMismatch': 'Il nome dell\'utente che esegue l\'attività non corrisponde al nome sul documento',
		'feedbackReview': 'Accettato provvisoriamente, in attesa di revisione',
		'documentVerified': 'Documento verificato',
		'lblCountry': 'Paese',
		'lblExpires': 'Scade',
		'lblUploadOrCapture': 'Carica o scatta una foto',
		'expiredError': 'Documento scaduto o scadrà troppo presto',
		'confirm': 'Conferma',
		'retry': 'Riprova',
		'error': 'Qualcosa è andato storto, riprova',
	},
	'NO': {
		'welcomeTitle': 'ID-kort identifikasjon',
		'welcomeReason': 'Vi må verifisere din identitet. Last opp et av de aksepterte dokumentene og oppgi din personlige informasjon.',
		'documentUploadTitle': 'Last opp ditt ID-dokument',
		'documentUploadText': 'Ta eller velg et bilde av dokumentet ditt hvor kantene er synlige og all tekst er tydelig lesbar.',
		'personalInfoTitle': 'Personlig informasjon',
		'personalInfoDescription': 'Oppgi din personlige informasjon. Felter merket med * er påkrevd.',
		'firstNameLabel': 'Fornavn',
		'lastNameLabel': 'Etternavn',
		'phoneLabel': 'Telefon',
		'dateOfBirthLabel': 'Fødselsdato',
		'idCardNumberLabel': 'ID-kortnummer',
		'companyLabel': 'Selskap',
		'licensePlateLabel': 'Skiltnummer',
		'fixedPhoneLineLabel': 'Fasttelefon',
		'selfieTitle': 'Ta et selfie',
		'selfieDescription': 'Ta et selfie for å fullføre identifikasjonen din.',
		'nationalIdLabel': 'Nasjonalt ID',
		'passportLabel': 'Pass',
		'driversLicenseLabel': 'Førerkort',
		'residencePermitLabel': 'Oppholdstillatelse',
		'orLabel': 'eller',
		'errorNotRecognised': 'Dokument ikke gjenkjent',
		'errorWrongType': 'Last opp riktig dokument eller et klart bilde av dokumentet.',
		'errorUnsupportedClass': 'Vi kunne ikke verifisere dette bildet. Last opp forsiden av det forespurte dokumentet.',
		'errorNameNotFound': 'Navn ikke funnet på dokumentet',
		'errorNameMismatch': 'Navnet på brukeren som utfører oppgaven samsvarer ikke med navnet på dokumentet',
		'feedbackReview': 'Foreløpig akseptert, venter på gjennomgang',
		'lblCountry': 'Land',
		'lblExpires': 'Utløper',
		'lblUploadOrCapture': 'Last opp eller ta et bilde',
		'expiredError': 'Dokument utløpt eller vil utløpe for snart',
		'confirm': 'Bekreft',
		'retry': 'Prøv igjen',
		'error': 'Noe gikk galt, vennligst prøv igjen',
	},
	'PT': {
		'welcomeTitle': 'Identificação com cartão de identidade',
		'welcomeReason': 'Precisamos verificar sua identidade. Por favor carregue um dos documentos aceitos e forneça suas informações pessoais.',
		'documentUploadTitle': 'Carregue seu documento de identidade',
		'documentUploadText': 'Capture ou selecione uma imagem do seu documento onde as bordas estão visíveis e todo o texto está claramente legível.',
		'personalInfoTitle': 'Informações pessoais',
		'personalInfoDescription': 'Por favor forneça suas informações pessoais. Campos marcados com * são obrigatórios.',
		'firstNameLabel': 'Primeiro nome',
		'lastNameLabel': 'Sobrenome',
		'phoneLabel': 'Telefone',
		'dateOfBirthLabel': 'Data de nascimento',
		'idCardNumberLabel': 'Número do cartão de identidade',
		'companyLabel': 'Empresa',
		'licensePlateLabel': 'Placa do veículo',
		'fixedPhoneLineLabel': 'Linha telefônica fixa',
		'selfieTitle': 'Tire uma selfie',
		'selfieDescription': 'Por favor tire uma selfie para completar sua identificação.',
		'nationalIdLabel': 'Cartão de identidade nacional',
		'passportLabel': 'Passaporte',
		'driversLicenseLabel': 'Carteira de motorista',
		'residencePermitLabel': 'Permissão de residência',
		'orLabel': 'ou',
		'errorNotRecognised': 'Documento não reconhecido',
		'errorWrongType': 'Por favor carregue o documento correto ou uma imagem clara do documento.',
		'errorUnsupportedClass': 'Não conseguimos verificar esta imagem. Por favor carregue o lado frontal do documento solicitado.',
		'errorNameNotFound': 'Nome não encontrado no documento',
		'errorNameMismatch': 'O nome do usuário realizando a tarefa não corresponde ao nome no documento',
		'feedbackReview': 'Aceito provisoriamente, aguardando revisão',
		'lblCountry': 'País',
		'lblExpires': 'Expira',
		'lblUploadOrCapture': 'Carregar ou tirar uma foto',
		'expiredError': 'Documento expirado ou expirará muito em breve',
		'confirm': 'Confirmar',
		'retry': 'Tentar novamente',
		'error': 'Algo deu errado, por favor tente novamente',
	},
	'RO': {
		'welcomeTitle': 'Identificare cu carte de identitate',
		'welcomeReason': 'Trebuie să verificăm identitatea dvs. Vă rugăm să încărcați unul dintre documentele acceptate și să furnizați informațiile dvs. personale.',
		'documentUploadTitle': 'Încărcați documentul dvs. de identitate',
		'documentUploadText': 'Captați sau selectați o imagine a documentului dvs. unde marginile sunt vizibile și tot textul este clar lizibil.',
		'personalInfoTitle': 'Informații personale',
		'personalInfoDescription': 'Vă rugăm să furnizați informațiile dvs. personale. Câmpurile marcate cu * sunt obligatorii.',
		'firstNameLabel': 'Prenume',
		'lastNameLabel': 'Nume de familie',
		'phoneLabel': 'Telefon',
		'dateOfBirthLabel': 'Data nașterii',
		'idCardNumberLabel': 'Număr carte de identitate',
		'companyLabel': 'Companie',
		'licensePlateLabel': 'Număr înmatriculare',
		'fixedPhoneLineLabel': 'Linie telefonică fixă',
		'selfieTitle': 'Faceți un selfie',
		'selfieDescription': 'Vă rugăm să faceți un selfie pentru a vă completa identificarea.',
		'nationalIdLabel': 'Carte de identitate națională',
		'passportLabel': 'Pașaport',
		'driversLicenseLabel': 'Permis de conducere',
		'residencePermitLabel': 'Permis de ședere',
		'orLabel': 'sau',
		'errorNotRecognised': 'Document nerecunoscut',
		'errorWrongType': 'Vă rugăm să încărcați documentul corect sau o imagine clară a documentului.',
		'errorUnsupportedClass': 'Nu am putut verifica această imagine. Vă rugăm să încărcați partea frontală a documentului solicitat.',
		'errorNameNotFound': 'Numele nu a fost găsit pe document',
		'errorNameMismatch': 'Numele utilizatorului care efectuează sarcina nu se potrivește cu numele de pe document',
		'feedbackReview': 'Acceptat provizoriu, în așteptarea revizuirii',
		'lblCountry': 'Țară',
		'lblExpires': 'Expiră',
		'lblUploadOrCapture': 'Încărcați sau faceți o fotografie',
		'expiredError': 'Document expirat sau va expira prea curând',
		'confirm': 'Confirmă',
		'retry': 'Reîncearcă',
		'error': 'Ceva a mers prost, vă rugăm să încercați din nou',
	},
	'RU': {
		'welcomeTitle': 'Идентификация по удостоверению личности',
		'welcomeReason': 'Нам нужно проверить вашу личность. Пожалуйста, загрузите один из принятых документов и предоставьте вашу личную информацию.',
		'documentUploadTitle': 'Загрузите ваш документ, удостоверяющий личность',
		'documentUploadText': 'Сделайте или выберите изображение вашего документа, где края видны и весь текст четко читаем.',
		'personalInfoTitle': 'Личная информация',
		'personalInfoDescription': 'Пожалуйста, предоставьте вашу личную информацию. Поля, помеченные *, обязательны.',
		'firstNameLabel': 'Имя',
		'lastNameLabel': 'Фамилия',
		'phoneLabel': 'Телефон',
		'dateOfBirthLabel': 'Дата рождения',
		'idCardNumberLabel': 'Номер удостоверения личности',
		'companyLabel': 'Компания',
		'licensePlateLabel': 'Номерной знак',
		'fixedPhoneLineLabel': 'Стационарный телефон',
		'selfieTitle': 'Сделайте селфи',
		'selfieDescription': 'Пожалуйста, сделайте селфи для завершения вашей идентификации.',
		'nationalIdLabel': 'Национальное удостоверение личности',
		'passportLabel': 'Паспорт',
		'driversLicenseLabel': 'Водительские права',
		'residencePermitLabel': 'Разрешение на проживание',
		'orLabel': 'или',
		'errorNotRecognised': 'Документ не распознан',
		'errorWrongType': 'Пожалуйста, загрузите правильный документ или четкое изображение документа.',
		'errorUnsupportedClass': 'Мы не смогли проверить это изображение. Пожалуйста, загрузите лицевую сторону запрошенного документа.',
		'errorNameNotFound': 'Имя не найдено в документе',
		'errorNameMismatch': 'Имя пользователя, выполняющего задачу, не соответствует имени в документе',
		'feedbackReview': 'Временно принят, ожидает проверки',
		'lblCountry': 'Страна',
		'lblExpires': 'Истекает',
		'lblUploadOrCapture': 'Загрузить или сделать фото',
		'expiredError': 'Документ истек или скоро истечет',
		'confirm': 'Подтвердить',
		'retry': 'Повторить',
		'error': 'Что-то пошло не так, пожалуйста, попробуйте снова',
	},
	'SK': {
		'welcomeTitle': 'Identifikácia pomocou občianskeho preukazu',
		'welcomeReason': 'Musíme overiť vašu identitu. Nahrajte prosím jeden z prijatých dokumentov a uveďte svoje osobné údaje.',
		'documentUploadTitle': 'Nahrajte svoj identifikačný dokument',
		'documentUploadText': 'Zhotovte alebo vyberte obrázok dokumentu, kde sú okraje viditeľné a všetok text je jasne čitateľný.',
		'personalInfoTitle': 'Osobné informácie',
		'personalInfoDescription': 'Uveďte prosím svoje osobné údaje. Polia označené * sú povinné.',
		'firstNameLabel': 'Meno',
		'lastNameLabel': 'Priezvisko',
		'phoneLabel': 'Telefón',
		'dateOfBirthLabel': 'Dátum narodenia',
		'idCardNumberLabel': 'Číslo občianskeho preukazu',
		'companyLabel': 'Spoločnosť',
		'licensePlateLabel': 'EČV',
		'fixedPhoneLineLabel': 'Pevná linka',
		'selfieTitle': 'Urobte selfie',
		'selfieDescription': 'Urobte prosím selfie pre dokončenie identifikácie.',
		'nationalIdLabel': 'Občiansky preukaz',
		'passportLabel': 'Cestovný pas',
		'driversLicenseLabel': 'Vodičský preukaz',
		'residencePermitLabel': 'Povolenie na pobyt',
		'orLabel': 'alebo',
		'errorNotRecognised': 'Dokument nebol rozpoznaný',
		'errorWrongType': 'Nahrajte prosím správny dokument alebo jasný obrázok dokumentu.',
		'errorUnsupportedClass': 'Nemohli sme overiť tento obrázok. Nahrajte prosím prednú stranu požadovaného dokumentu.',
		'errorNameNotFound': 'Meno nebolo nájdené na dokumente',
		'errorNameMismatch': 'Meno používateľa vykonávajúceho úlohu nezodpovedá menu na dokumente',
		'feedbackReview': 'Predbežne akceptovaný, čaká na kontrolu',
		'lblCountry': 'Krajina',
		'lblExpires': 'Vyprší',
		'lblUploadOrCapture': 'Nahrať alebo urobiť obrázok',
		'expiredError': 'Dokument vypršal alebo vyprší príliš skoro',
		'confirm': 'Potvrdiť',
		'retry': 'Skúsiť znovu',
		'error': 'Niečo sa pokazilo, skúste to prosím znovu',
	},
	'SI': {
		'welcomeTitle': 'Identifikacija z osebno izkaznico',
		'welcomeReason': 'Moramo potrditi vašo identiteto. Prosimo, naložite enega od sprejetih dokumentov in navedite svoje osebne podatke.',
		'documentUploadTitle': 'Naložite svoj identifikacijski dokument',
		'documentUploadText': 'Ustvarite ali izberite sliko dokumenta, kjer so robovi vidni in ves tekst jasno berljiv.',
		'personalInfoTitle': 'Osebne informacije',
		'personalInfoDescription': 'Prosimo, navedite svoje osebne podatke. Polja označena z * so obvezna.',
		'firstNameLabel': 'Ime',
		'lastNameLabel': 'Priimek',
		'phoneLabel': 'Telefon',
		'dateOfBirthLabel': 'Datum rojstva',
		'idCardNumberLabel': 'Številka osebne izkaznice',
		'companyLabel': 'Podjetje',
		'licensePlateLabel': 'Registrska številka',
		'fixedPhoneLineLabel': 'Fiksna telefonska linija',
		'selfieTitle': 'Naredite selfie',
		'selfieDescription': 'Prosimo, naredite selfie za dokončanje identifikacije.',
		'nationalIdLabel': 'Osebna izkaznica',
		'passportLabel': 'Potni list',
		'driversLicenseLabel': 'Vozniško dovoljenje',
		'residencePermitLabel': 'Dovoljenje za bivanje',
		'orLabel': 'ali',
		'errorNotRecognised': 'Dokument ni prepoznan',
		'errorWrongType': 'Prosimo, naložite pravilen dokument ali jasno sliko dokumenta.',
		'errorUnsupportedClass': 'Nismo mogli potrditi te slike. Prosimo, naložite sprednjo stran zahtevanega dokumenta.',
		'errorNameNotFound': 'Ime ni bilo najdeno na dokumentu',
		'errorNameMismatch': 'Ime uporabnika, ki izvaja nalogo, se ne ujema z imenom na dokumentu',
		'feedbackReview': 'Začasno sprejeto, čaka na pregled',
		'lblCountry': 'Država',
		'lblExpires': 'Izteče',
		'lblUploadOrCapture': 'Naložite ali naredite fotografijo',
		'expiredError': 'Dokument je potekel ali bo kmalu potekel',
		'confirm': 'Potrdi',
		'retry': 'Poskusi ponovno',
		'error': 'Nekaj je šlo narobe, prosimo poskusite ponovno',
	},
	'SV': {
		'welcomeTitle': 'ID-kort identifiering',
		'welcomeReason': 'Vi behöver verifiera din identitet. Ladda upp ett av de accepterade dokumenten och ange din personliga information.',
		'documentUploadTitle': 'Ladda upp ditt ID-dokument',
		'documentUploadText': 'Fånga eller välj en bild av ditt dokument där kanterna är synliga och all text är tydligt läsbar.',
		'personalInfoTitle': 'Personlig information',
		'personalInfoDescription': 'Ange din personliga information. Fält markerade med * är obligatoriska.',
		'firstNameLabel': 'Förnamn',
		'lastNameLabel': 'Efternamn',
		'phoneLabel': 'Telefon',
		'dateOfBirthLabel': 'Födelsedatum',
		'idCardNumberLabel': 'ID-kortnummer',
		'companyLabel': 'Företag',
		'licensePlateLabel': 'Registreringsnummer',
		'fixedPhoneLineLabel': 'Fast telefon',
		'selfieTitle': 'Ta en selfie',
		'selfieDescription': 'Ta en selfie för att slutföra din identifiering.',
		'nationalIdLabel': 'Nationellt ID',
		'passportLabel': 'Pass',
		'driversLicenseLabel': 'Körkort',
		'residencePermitLabel': 'Uppehållstillstånd',
		'orLabel': 'eller',
		'errorNotRecognised': 'Dokument inte igenkänt',
		'errorWrongType': 'Ladda upp korrekt dokument eller en tydlig bild av dokumentet.',
		'errorUnsupportedClass': 'Vi kunde inte verifiera denna bild. Ladda upp framsidan av det begärda dokumentet.',
		'errorNameNotFound': 'Namnet hittades inte på dokumentet',
		'errorNameMismatch': 'Namnet på användaren som utför uppgiften matchar inte namnet på dokumentet',
		'feedbackReview': 'Villkorligt godkänd, väntar på granskning',
		'lblCountry': 'Land',
		'lblExpires': 'Förfaller',
		'lblUploadOrCapture': 'Ladda upp eller ta en bild',
		'expiredError': 'Dokumentet har utgått eller kommer att gå ut för snart',
		'confirm': 'Bekräfta',
		'retry': 'Försök igen',
		'error': 'Något gick fel, vänligen försök igen',
	},
	'TR': {
		'welcomeTitle': 'Kimlik kartı ile kimlik doğrulama',
		'welcomeReason': 'Kimliğinizi doğrulamamız gerekiyor. Lütfen kabul edilen belgelerden birini yükleyin ve kişisel bilgilerinizi sağlayın.',
		'documentUploadTitle': 'Kimlik belgenizi yükleyin',
		'documentUploadText': 'Kenarların görünür olduğu ve tüm metnin açıkça okunabilir olduğu belgenizin bir görüntüsünü çekin veya seçin.',
		'personalInfoTitle': 'Kişisel bilgiler',
		'personalInfoDescription': 'Lütfen kişisel bilgilerinizi sağlayın. * ile işaretlenmiş alanlar zorunludur.',
		'firstNameLabel': 'Ad',
		'lastNameLabel': 'Soyad',
		'phoneLabel': 'Telefon',
		'dateOfBirthLabel': 'Doğum tarihi',
		'idCardNumberLabel': 'Kimlik kartı numarası',
		'companyLabel': 'Şirket',
		'licensePlateLabel': 'Plaka',
		'fixedPhoneLineLabel': 'Sabit telefon hattı',
		'selfieTitle': 'Selfie çekin',
		'selfieDescription': 'Kimlik doğrulamanızı tamamlamak için lütfen bir selfie çekin.',
		'nationalIdLabel': 'Ulusal kimlik',
		'passportLabel': 'Pasaport',
		'driversLicenseLabel': 'Sürücü belgesi',
		'residencePermitLabel': 'İkamet izni',
		'orLabel': 'veya',
		'errorNotRecognised': 'Belge tanınmadı',
		'errorWrongType': 'Lütfen doğru belgeyi veya belgenin net bir görüntüsünü yükleyin.',
		'errorUnsupportedClass': 'Bu görüntüyü doğrulayamadık. Lütfen istenen belgenin ön yüzünü yükleyin.',
		'errorNameNotFound': 'Belgede isim bulunamadı',
		'errorNameMismatch': 'Görevi gerçekleştiren kullanıcının adı belgedeki adla eşleşmiyor',
		'feedbackReview': 'Geçici olarak kabul edildi, inceleme bekleniyor',
		'lblCountry': 'Ülke',
		'lblExpires': 'Doluyor',
		'lblUploadOrCapture': 'Yükle veya fotoğraf çek',
		'expiredError': 'Belge süresi dolmuş veya çok yakında dolacak',
		'confirm': 'Onayla',
		'retry': 'Tekrar dene',
		'error': 'Bir şeyler yanlış gitti, lütfen tekrar deneyin',
	},
	'UK': {
		'welcomeTitle': 'Ідентифікація за посвідченням особи',
		'welcomeReason': 'Нам потрібно перевірити вашу особу. Будь ласка, завантажте один з прийнятих документів і надайте вашу особисту інформацію.',
		'documentUploadTitle': 'Завантажте ваш документ, що посвідчує особу',
		'documentUploadText': 'Зробіть або виберіть зображення вашого документа, де краї видні і весь текст чітко читається.',
		'personalInfoTitle': 'Особиста інформація',
		'personalInfoDescription': 'Будь ласка, надайте вашу особисту інформацію. Поля, позначені *, є обов\'язковими.',
		'firstNameLabel': 'Ім\'я',
		'lastNameLabel': 'Прізвище',
		'phoneLabel': 'Телефон',
		'dateOfBirthLabel': 'Дата народження',
		'idCardNumberLabel': 'Номер посвідчення особи',
		'companyLabel': 'Компанія',
		'licensePlateLabel': 'Номерний знак',
		'fixedPhoneLineLabel': 'Стаціонарний телефон',
		'selfieTitle': 'Зробіть селфі',
		'selfieDescription': 'Будь ласка, зробіть селфі для завершення вашої ідентифікації.',
		'nationalIdLabel': 'Національне посвідчення особи',
		'passportLabel': 'Паспорт',
		'driversLicenseLabel': 'Водійські права',
		'residencePermitLabel': 'Дозвіл на проживання',
		'orLabel': 'або',
		'errorNotRecognised': 'Документ не розпізнано',
		'errorWrongType': 'Будь ласка, завантажте правильний документ або чітке зображення документа.',
		'errorUnsupportedClass': 'Ми не змогли перевірити це зображення. Будь ласка, завантажте лицьову сторону запитуваного документа.',
		'errorNameNotFound': 'Ім\'я не знайдено в документі',
		'errorNameMismatch': 'Ім\'я користувача, що виконує завдання, не відповідає імені в документі',
		'feedbackReview': 'Тимчасово прийнято, очікує перевірки',
		'lblCountry': 'Країна',
		'lblExpires': 'Закінчується',
		'lblUploadOrCapture': 'Завантажити або зробити фото',
		'expiredError': 'Документ закінчився або скоро закінчиться',
		'confirm': 'Підтвердити',
		'retry': 'Повторити',
		'error': 'Щось пішло не так, будь ласка спробуйте ще раз',
	},
};

export function getTextDefaults(lang) {
	// Merge over EN so keys missing in a translation fall back to English instead of rendering `undefined`.
	return { ...textDefaults['EN'], ...(textDefaults[lang.toUpperCase()] || {}) };
}

export function getLanguages() {
	return Object.keys(textDefaults);
}

